import React, { useState } from "react";
import DataGrid from "./DataGrid/DataGrid.tsx";
import { PolicyDetails } from "../PolicyDetails/PolicyDetails.tsx";

interface Policy {
  policyId: string;
  documentNumber: string;
  insuranceCompany: string;
  insuranceType: string;
  agent: string;
  status: string;
  policyNumber?: string;
}

interface SearchResultsDataGridProps {
  policies: Policy[];
  isLoading: boolean;
  documentType?: number;
}

const DocumentSearchDataGrid: React.FC<SearchResultsDataGridProps> = ({
  policies,
  isLoading,
  documentType,
}) => {
  const [selectedPolicyId, setSelectedPolicyId] = useState<string | null>(null);

  const handleRowClick = ({ data }: { data: Policy }) => {
    setSelectedPolicyId(data.policyId);
  };

  const showPolicyNumber = documentType == 2 || documentType == 4;

  const columns = [
    {
      name: "documentNumber",
      header: "No Документ",
      minWidth: 70,
      type: "string",
    },
    ...(showPolicyNumber
      ? [
          {
            name: "policyNumber",
            header: "No Полица",
            minWidth: 90,
            type: "string",
          },
        ]
      : []),
    {
      name: "insuranceCompany",
      header: "ЗК",
      minWidth: 110,
      type: "string",
    },
    {
      name: "insuranceType",
      header: "Вид Застраховка",
      minWidth: 110,
      type: "string",
    },
    {
      name: "agent",
      header: "Агент",
      minWidth: 90,
      type: "string",
    },
    {
      name: "status",
      header: "Статус",
      minWidth: 70,
      type: "string",
    },
  ];

  return (
    <>
      <DataGrid
        columns={columns}
        dataSource={policies}
        isLoading={isLoading}
        gridTitle="Резултати от търсенето"
        idProperty="documentNumber"
        csvFilename="search_results.csv"
        icon="fa-kit fa-search"
        editable={false}
        onRowClick={(row) => handleRowClick(row)}
      />
      {selectedPolicyId && <PolicyDetails policyId={selectedPolicyId} />}
    </>
  );
};

export default DocumentSearchDataGrid;
